const undefinedSymbol = Symbol('undefined');
async function multiArrayCache (arrayCache, ttl, ids, fn, options) {
    const resultMap = {};
    const missingIds = [];

    if (options && options.refresh) {
        // Simply treat all ids as missing when refresh is requested
        missingIds.push(...ids);
    } else {
        for (const id of ids) {
            const res = arrayCache.get(String(id));
            if (options && options.willInsertMissing && (res === undefinedSymbol || ! res)) {
                missingIds.push(id);
            } else if (res === undefinedSymbol) {
                // do nothing, cached as missing
            } else if (res === undefined) {
                missingIds.push(id);
            } else {
                resultMap[id] = res;
            }
        }
    }

    if (missingIds.length === 0) {
        return resultMap;
    }

    const loadedEntityMap = await fn(missingIds);

    for (const id in loadedEntityMap) {
        const value = loadedEntityMap[id];
        resultMap[id] = value;
        arrayCache.set(String(id), value, ttl);
    }

    for (const id of missingIds) {
        if (! (id in resultMap)) {
            if (options && options.willInsertMissing) {
                console.error('Error in multiArrayCache, was expected to insert but still missing id ' + id);
            }
            if (options && options.noWriteCache) {
                continue;
            }
            arrayCache.set(String(id), undefinedSymbol, ttl);
        }
    }

    return resultMap;
}

module.exports = multiArrayCache;
